











































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

import { Code } from "@/types";
import { all as codes, excludes } from "@/codes";
import Tooltip from "@/components/Tooltip.vue";
import IntersectionSentinel from "@/components/IntersectionSentinel.vue";

const PER_PAGE = 10;

@Component({
  components: { IntersectionSentinel, Tooltip }
})
export default class CodeList extends Vue {
  private codes: Code[] = [];

  private loaded: boolean = false;

  @Prop()
  private reference!: string;

  @Prop()
  private existing!: string[];

  @Emit("selected")
  select(code: Code) {}

  get code() {
    return codes.find(code => code.id === this.reference);
  }

  loadBefore() {
    if (this.loaded) {
      const initialHeight = this.$el.scrollHeight;

      this.codes.unshift(
        ...codes.slice(
          CodeList.secure(this.codes[0].index - PER_PAGE - 1),
          CodeList.secure(this.codes[0].index - 1)
        )
      );

      this.$nextTick(() => {
        this.$el.scrollTop = this.$el.scrollHeight - initialHeight;
      });
    }
  }

  loadAfter() {
    if (this.loaded) {
      this.codes.push(
        ...codes.slice(
          CodeList.secure(this.codes[this.codes.length - 1].index + 1),
          CodeList.secure(
            this.codes[this.codes.length - 1].index + PER_PAGE + 1
          )
        )
      );
    }
  }

  mounted() {
    this.calculate();
  }

  @Watch("codes")
  markAsUpdated() {
    this.$emit("updated");
  }

  static secure(index: number) {
    if (index < 0) return 0;
    if (index > codes.length) return codes.length;
    return index;
  }

  @Watch("reference")
  private calculate() {
    if (this.reference) {
      this.loaded = false;

      const element = this.$el as HTMLElement;
      element.style.maxHeight = "initial";

      if (this.code) {
        this.codes = codes.slice(
          CodeList.secure(this.code.index - PER_PAGE),
          CodeList.secure(this.code.index + PER_PAGE)
        );
      }

      this.$nextTick(() => {
        const item = this.$el.querySelector(`[data-code="${this.reference}"]`);

        if (item) {
          element.style.maxHeight = `${element.clientHeight - 10}px`;

          item.scrollIntoView({
            block: "center"
          });

          this.loaded = true;
        }
      });
    }
  }

  isExcluded(code: Code) {
    return (excludes[code.id] || []).filter(value =>
      this.existing.includes(value)
    );
  }
}
